import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';
import TaxonomyExpertiseCard from '../../../../../implementations/Taxonomy/Expertise/Card';
import type { SearchAllContentExpertiseHit } from '../../../../SearchAllContent/types';

const MetaSearchExpertiseHit: React.FC<{ hit: SearchAllContentExpertiseHit }> = ({ hit }) => (
  <TaxonomyExpertiseCard
    title={hit.taxonomy_name[0]}
    subtitle={hit.taxonomy_description?.[0]}
    link={hit.url[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['4_3', '4_3', '4_3', '4_3', '4_3'],
          ['sm', 'xs', 'xs', 'sm', 'sm'],
        )}
        alt=""
        lazyload={false}
        role="presentation"
      />
    )}
  />
);

export default MetaSearchExpertiseHit;
